var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-wrapper"},[_c('router-link',{staticClass:"more",attrs:{"to":_vm.to}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }